export enum BlockCreateInvoiceActionReason {
  DepositInvoiceDraftExists = 'depositInvoiceDraftExists',
  DepositInvoiceUnpaid = 'depositInvoiceUnpaid',
  FinalInvoiceDraftAlreadyExists = 'finalInvoiceDraftAlreadyExists',
  RegularInvoiceDraftExists = 'regularInvoiceDraftExists',
}
